import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
// const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'brand_bq': {
    title: '品牌（bq）',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  }
}

export default {
  'product_id': {
    title: '产品编号',
    type: 'input',
    equation: all,
    width: 180
  },
  'short_text': {
    title: '产品描述',
    type: 'input',
    equation: all,
    width: 400
  },
  'zzfld00001h': {
    title: '营销单元编码',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'zzfld00001h_text': {
    title: '营销单元描述'
  },
  'chfl': {
    describe: true,
    suffix: '_value_kt',
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 150
  },
  'ycate': {
    describe: true,
    suffix: '_value_kt',
    title: '月报分类',
    type: 'select',
    equation: city,
    dictionary: 'A0016'
  },
  'pcate': {
    describe: true,
    suffix: '_value_kt',
    title: '产品分类',
    type: 'select',
    equation: city,
    dictionary: 'A0028'
  },
  'brand': {
    describe: true,
    suffix: '_value_kt',
    title: '品牌（bq）',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  }
}



// WEBPACK FOOTER //
// ./src/views/product-manage/config/productMarketingUnitQuery.js